export const printFileSize = (sizeInBytes: number) => {
    if (sizeInBytes < 1024) {
        return sizeInBytes + " bytes";
    }
    if (sizeInBytes < 1024 * 1024) {
        return Math.round(sizeInBytes / 1024) + "KB";
    }
    return Math.round(sizeInBytes / 1024 / 1024) + "MB";
};
